import { API_BASE_URL } from "./urlConfig";

/**
 * Central registry of every API endpoint used by the application.
 *
 * All action files import from here — never construct URLs inline.
 *
 * Pattern:
 *   ATP_API_URL.SomeName  -->  full URL string ready for axios / fetch
 */
export const ATP_API_URL = {
  // ── Device / Brands ─────────────────────────────────────────────────────
  GetBrands: `https://portal.acrossassist.com/api/partner/v1/dmi/GetBrands`,

  // TODO: Plan details API call
  // GetPlans: `${API_BASE_URL}/api/partner/v1/dmi/GetPlans`,
  // GetPlan  "https://gadgetuatapi.acrossassist.in/api/partner/v1/gadget/GetPlanDetails",
  GetPlanDetails:
    "https://portal.acrossassist.com/api/partner/v1/gadget/GetPlanDetails", // PROD URLS TO PLANs
  // GetPlanDetails: `${API_BASE_URL}/api/partner/v1/gadget/GetPlanDetails`,
  // ── Enrollment ───────────────────────────────────────────────────────────
  // Step 1: Save gadget details, get customerId
  SaveGadgetDetails: `${API_BASE_URL}/api/partner/v1/gadget/SaveGadgetDetails`,

  // Step 2: Send payment request with userId (customerId from step 1)
  SendGadgetPaymentRequest: `${API_BASE_URL}/api/partner/v1/gadget/SendGadgetPaymentRequest`,
};
